module.exports = __webpack_public_path__ + "f8613d295cf803bf90068bbb8e575ee3.svg";